<template>
  <div class="mian_c">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div style="font-size: 0.35rem; margin-left: -0.2rem">
            税费计算器
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="tab_con">
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)">新房</span>
      <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
        >二手房</span
      >
    </div>
    <div class="intermediate">
      <van-field
        v-model="value1"
        label="住宅类型"
        placeholder="请选择住宅类型"
        readonly
        clickable
        @click="residenceType = true"
      />
      <van-popup v-model="residenceType" position="bottom">
        <van-picker
          show-toolbar
          :columns="residenceTypeList"
          @confirm="residenceTypeConfirm"
          @cancel="residenceType = false"
        />
      </van-popup>
      <van-field
        v-show="tab == 2 && value1 == '普通住宅'"
        v-model="value2"
        label="房屋类型"
        placeholder="请选择房屋类型"
        readonly
        clickable
        @click="houseType = true"
      />
      <van-popup v-model="houseType" position="bottom">
        <van-picker
          show-toolbar
          :columns="houseTypeList"
          @confirm="houseTypeConfirm"
          @cancel="houseType = false"
        />
      </van-popup>
      <van-field
        v-show="tab == 2"
        v-model="value3"
        label="计算方式"
        placeholder="请选择计算方式"
        readonly
        clickable
        @click="calculationType = true"
      />
      <van-popup v-model="calculationType" position="bottom">
        <van-picker
          show-toolbar
          :columns="calculationTypeList"
          @confirm="calculationTypeConfirm"
          @cancel="calculationType = false"
        />
      </van-popup>
      <van-field
        v-show="tab == 2"
        v-model="value4"
        label="房产购置年限"
        placeholder="请选择房产购置年限"
        readonly
        clickable
        @click="houseYear = true"
      />
      <van-popup v-model="houseYear" position="bottom">
        <van-picker
          show-toolbar
          :columns="houseYearList"
          @confirm="houseYearConfirm"
          @cancel="houseYear = false"
        />
      </van-popup>
      <van-field v-model="value5" label="建筑面积" placeholder="请输入商贷金额">
        <template #button>
          <div class="b_pad">平米</div>
        </template>
      </van-field>
      <van-field
        v-show="tab == 1"
        v-model="value6"
        label="单价"
        placeholder="请输入商贷金额"
      >
        <template #button>
          <div class="b_pad">元/平米</div>
        </template>
      </van-field>
      <van-field name="radio" label="是否首次购房">
        <template #input>
          <van-radio-group v-model="checked" direction="horizontal">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="2" shape="square">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field name="radio" label="是否包含电梯" v-show="tab == 1">
        <template #input>
          <van-radio-group v-model="checked2" direction="horizontal">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="2" shape="square">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="radio"
        label="是否唯一住房"
        v-show="tab == 2 && value1 == '普通住宅'"
      >
        <template #input>
          <van-radio-group v-model="checked3" direction="horizontal">
            <van-radio name="1" shape="square">是</van-radio>
            <van-radio name="2" shape="square">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-show="tab == 2"
        v-model="value7"
        label="总价"
        placeholder="请输入商贷金额"
      >
        <template #button>
          <div class="b_pad">万元</div>
        </template>
      </van-field>
      <van-field
        v-show="tab == 2 && value3 == '按差价计算'"
        v-model="value8"
        label="原价"
        placeholder="请输入商贷金额"
      >
        <template #button>
          <div class="b_pad">万元</div>
        </template>
      </van-field>
      <van-field
        v-show="tab == 2 && value3 == '按差价计算'"
        v-model="value9"
        label="原始契税"
        placeholder="请输入商贷金额"
      >
        <template #button>
          <div class="b_pad">万元</div>
        </template>
      </van-field>

      <div class="btn">
        <p>开始计算</p>
      </div>
    </div>
  </div>
</template>
<script>
import appHeader from "@/components/appHeader";
export default {
  data() {
    return {
      residenceType: false,
      calculationType: false,
      houseType: false,
      houseYear: false,
      residenceTypeList: ["非普通住宅", "普通住宅"],
      calculationTypeList: ["按总价计算", "按差价计算"],
      houseTypeList: ["商品房", "一类经济适应房", "二类经济适应房"],
      houseYearList: ["2年以内", "2-5年", "5年以上"],
      checked: "1",
      checked2: "1",
      checked3: "1",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      tab: 1,
      radio: "1",
      rateList: ["按旧版基准利率", "按LRP"],
    };
  },
  components: {
    appHeader,
  },
  methods: {
    goback() {},
    residenceTypeConfirm(value) {
      this.value1 = value;
      this.residenceType=false
    },
    calculationTypeConfirm(value) {
      this.value3 = value;
      this.calculationType=false
    },
    houseTypeConfirm(value) {
      this.houseType=false
    },
     houseYearConfirm(value) {
      this.houseYear=false
    },
    changeTab(type) {
      this.tab = type;
      // if (type == 0) {
      //   this.definition = "人才";
      // }
      // if (type == 1) {
      //   this.definition = "刚需";
      // }
      // if (type == 2) {
      //   this.definition = "普通";
      // }
    },
  },
};
</script>
 <style lang="less" scoped>
.btn {
  margin-top: 1rem;
  padding: 0 2rem;
  p {
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    background: #007fff;
    color: #fff;
  }
}
.row_t {
  text-align: center;
  margin: 0.6rem 0;
  background: #ccffff;
  display: flex;
  padding: 20px 10px;
  justify-content: center;
  align-items: center;
  p {
    padding: 0.1rem 0;
    color: #fff;
    border-radius: 5px;
    background: #007fff;
    flex: 2;
  }
  div {
    flex: 7;
  }
}
.wra_block {
  border-radius: 5px;
  width: 4.5rem;
  // height: 8rem;
  color: #000;
  background: #fff;
  padding: 0.2rem 0.3rem;
  .block_tit {
    padding: 0.2rem 0;
    font-size: 0.3rem;
    font-weight: 900;
  }
  .block_btn {
    margin-top: 0.3rem;
    // padding: 0 1.5rem;
    p {
      padding: 0.1rem 0;
      background: #007fff;
      border-radius: 5px;
      text-align: center;
      color: #fff;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    td,
    th {
      border: 1px solid #000;
    }
  }
}
.mian_c {
  padding: 0 0.1rem;
  .fixed_pad {
    padding-top: 1.1rem;
  }
  .top_header {
    height: 0.5rem;
    padding: 0.2rem 0rem;
    width: 7.04rem;
    margin: 0 auto;
  }
  .fixed {
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9;
    .top_normal {
      height: 100%;
      i {
        font-size: 0.32rem;
      }
    }
  }
}
.intermediate {
  // padding: 0 0.3rem;
  .row_f {
    padding: 10px 16px;
    border-bottom: 1px solid #e5e5e5;
  }
  .accumulation {
    border-top: 10px solid #e5e5e5;
    border-bottom: 10px solid #e5e5e5;
  }
  .b_pad {
    padding-right: 0.5rem;
  }
}
.tab_con {
  padding-bottom: 0.2rem;
  border-bottom: 2px solid #e5e5e5;
  display: flex;
  height: 1rem;
  background-color: #fff;
  z-index: 9;
  span {
    text-align: center;
    flex: 1;
    font-size: 0.3rem;
    font-weight: 800;
    margin: 0.3rem;
    position: relative;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 1.1rem;
      height: 0.04rem;
    }
  }
}
</style>